import { render, staticRenderFns } from "./SaveDashboardConfigurationModal.vue?vue&type=template&id=e5fc0356"
import script from "./SaveDashboardConfigurationModal.vue?vue&type=script&lang=ts"
export * from "./SaveDashboardConfigurationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports